import React, { FC } from 'react';

interface SurveyQuestionAnswerIconProps {
  color?: string;
  width?: string;
  height?: string;
  className?: string;
}

export const SurveyQuestionAnswerIcon: FC<
  React.PropsWithChildren<SurveyQuestionAnswerIconProps>
> = ({ color = 'black', width = '24', height = '24', className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="surveys">
        <path
          id="icon/action/question_answer_24px"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM15 4V11H5.17L4.58 11.59L4 12.17V4H15ZM19 6H21C21.55 6 22 6.45 22 7V22L18 18H7C6.45 18 6 17.55 6 17V15H19V6Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
